'use client';

import { useBoundaryError } from '@/hooks/useBoundaryError';

// Letzter Fallback: greift, wenn selbst das Root-Layout beim Rendern crasht.
// Muss eigene <html>/<body>-Tags rendern (ersetzt das Root-Layout komplett) und
// nutzt Inline-Styles, damit die Seite auch ohne geladenes Stylesheet lesbar ist.
// Retry bewusst per window.location.reload() statt reset(): ohne Root-Layout ist
// kein Router-Kontext garantiert, und ein beim Rendern gecrashtes Root-Layout
// heilt ohnehin nur ein voller Neuladen.
export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useBoundaryError(error, { label: '[GlobalError]' });

  return (
    <html lang="de">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f8fafc',
          fontFamily:
            'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
          color: '#1e293b',
          padding: '2rem',
        }}
      >
        <div style={{ textAlign: 'center', maxWidth: '28rem' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700, margin: '0 0 0.5rem' }}>
            Etwas ist schiefgelaufen
          </h2>
          <p style={{ color: '#64748b', margin: '0 0 1.5rem' }}>
            Ein unerwarteter Fehler ist aufgetreten. Bitte lade die Seite neu.
            Falls es weiterhin nicht geht, melde dich bei kontakt@checkpoint-edu.ch.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '0.65rem 1.4rem',
              fontSize: '1rem',
              fontWeight: 600,
              color: '#ffffff',
              background: '#4f46e5',
              border: 'none',
              borderRadius: '0.75rem',
              cursor: 'pointer',
            }}
          >
            Seite neu laden
          </button>
        </div>
      </body>
    </html>
  );
}
